import {Platform} from 'react-native';
import {AnyAction, applyMiddleware, compose, createStore} from 'redux';
import {createLogger} from 'redux-logger';
import thunk, {ThunkMiddleware, ThunkDispatch} from 'redux-thunk';
import {TypedUseSelectorHook, useDispatch as useReduxDispatch, useSelector as useReduxSelector} from 'react-redux';

import rootReducer, {AppStore} from './reducers';

const logger = createLogger({
  collapsed: true,
  duration: true,
  level: 'error',
});

export type AppState = ReturnType<typeof rootReducer>;
export type AppDispatch = ThunkDispatch<AppState, unknown, AnyAction>;

// Typed hooks - use these instead of plain useDispatch and useSelector
export const useAppDispatch = () => useReduxDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<AppState> = useReduxSelector;

const middleware = [thunk as ThunkMiddleware<AppState>];
if (Platform.OS === 'web' && process.env.NODE_ENV !== 'production') {
  middleware.push(logger);
}

const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const defaultState = {};

const enhancer = composeEnhancers(applyMiddleware(...middleware));

const configureStore = () => createStore<AppStore, AnyAction, {}, {}>(rootReducer, defaultState as AppState, enhancer);

export const store = configureStore();
